import React from 'react';
import boomiLogo from '../../../img/boomi-logo.svg';

const BrandedModal = ({ children }) => (
    <div className="boomi-branded-dialog">
        <div className="modal-backdrop full-height" />
        <div className="modal show">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <img src={boomiLogo} width={190} height={56} alt="Boomi" />
                    </div>
                    {
                        children
                    }
                </div>
            </div>
        </div>
    </div>
);

export default BrandedModal;
